import React, { useEffect, useState } from "react";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, fetchSubscription, getFreeSubscriptionDaysLeft } from "../../../redux/actions/userActions";
// NAVIGATE
import { useNavigate } from "react-router-dom";
import Slider from "@mui/material/Slider";
import SubscriptionCard from "./SubscriptionCard";
import SubscriptionCardCustom from "./SubscriptionCardCustom";
import ComponentLoading from "../../../commonComponents/ComponentLoading";
import matchers from "@testing-library/jest-dom/matchers";

const Subscription = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const fetchProducts_rd = () => dispatch(fetchProducts());
  const products = useSelector((state) => (state.user.products ? state.user.products : null));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const subscription = useSelector((state) => (state.user.subscription ? state.user.subscription : null));
  const current_period = useSelector((state) => (state.user.subscription_days_left ? state.user.subscription_days_left : null));

  const [data, setData] = useState(null);
  const [cancel_at_period_end, set_cancel_at_period_end] = useState(null);
  const [cond_subscription, set_cond_subscription] = useState(null);

  useEffect(() => {
    if (products) {
      setData(Object.entries(products).filter((x) => x[1].metadata && x[1].metadata.is_main_plan === "1" && !x[1].name.includes("Free")));
      if (subscription) {
        set_cancel_at_period_end(Object.values(subscription)[0].cancel_at_period_end);
      }
    }
  }, [products]);

  useEffect(() => {
    if (data) {
      if (subscription) {
        set_cond_subscription(!cancel_at_period_end && data.some((y) => Object.values(subscription)[0].items.some((x) => x.plan.product === y[0])));
      }
    }
  }, [data]);

  const get_free_trial_message = () => {
    if (parseFloat(getFreeSubscriptionDaysLeft(user_info)) > 0) {
      // return "Essai gratuit : " + parseFloat(getFreeSubscriptionDaysLeft(user_info)).toFixed(0) + " jours restant.";
      return "Essai gratuit : 20 jours restant.";
    } else {
      return "Essai gratuit : 0 jours restants.";
    }
  };
  return (
    <>
      {products && data ? (
        <>
          <div className="w-full flex justify-center items-center h-[60px]">
            <div className="w-[900px] h-full border-b-[1px] border-black flex items-center align-bottom justify-between">
              <p className="text-xl font-Poppins-SemiBold">Pricing simple et transparent</p>
              {!cond_subscription && <p className="text-sm font-Poppins-Light">{get_free_trial_message()}</p>}
            </div>
          </div>
          <div className="w-full flex mt-[10px] justify-center ">
            <div className="flex flex-row  bg-slate-200 rounded-lg">
              {data.map((x) => {
                const productsStandardId = products?.[Object.keys(products).find((key) => products[key].name === "Products Standard Plan")]?.prices?.priceId;
                const usersStandardId = products?.[Object.keys(products).find((key) => products[key].name === "Users Standard Plan")]?.prices?.priceId;
                const productsEssentialId = products?.[Object.keys(products).find((key) => products[key].name === "Products Essential Plan")]?.prices?.priceId;
                const usersEssentialId = products?.[Object.keys(products).find((key) => products[key].name === "Users Essential Plan")]?.prices?.priceId;
                const productsStandardProduct = products?.[Object.keys(products).find((key) => products[key].name === "Products Standard Plan")]?.[0];
                const usersStandardProduct = products?.[Object.keys(products).find((key) => products[key].name === "Users Standard Plan")]?.[0];
                const productsEssentialProduct = products?.[Object.keys(products).find((key) => products[key].name === "Products Essential Plan")]?.[0];
                const usersEssentialProduct = products?.[Object.keys(products).find((key) => products[key].name === "Users Essential Plan")]?.[0];
                const hasPrices = productsStandardId && usersStandardId && productsEssentialId && usersEssentialId;
                if (hasPrices) {
                  return (
                    <div key={x[0]} className="p-2">
                      <SubscriptionCard
                        key={x[0]}
                        data={x}
                        products_standard_id={productsStandardId}
                        users_standard_id={usersStandardId}
                        products_standard_product={productsStandardProduct}
                        users_standard_product={usersStandardProduct}
                        products_essential_id={productsEssentialId}
                        users_essential_id={usersEssentialId}
                        products_essential_product={productsEssentialProduct}
                        users_essential_product={usersEssentialProduct}
                      />
                    </div>
                  );
                }
                return null;
              })}
              <div className="p-2">
                <SubscriptionCardCustom />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
        </>
      )}
    </>
  );
};

export default Subscription;
